import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/icon.jpeg'


const _hoisted_1 = { class: "w-full font-montserrat relative" }
const _hoisted_2 = { class: "relative mb-[50px] w-full" }
const _hoisted_3 = { class: "p-[20px] flex flex-col items-center relative bg-gray-50 min-h-screen top-[60px]" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-black font-bold py-[20px] text-center" }, "Home / Profil", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl uppercase font-bold text-center text-black py-[20px]" }, "Profile", -1)
const _hoisted_6 = { class: "block md:flex justify-center w-[90%] py-[10px]" }
const _hoisted_7 = { class: "md:w-[200px] p-[10px] w-full md:h-[200px] bg-white md:mx-[10px] flex flex-col justify-center items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-[120px] h-[120px] rounded-[50%] border border-black"
}, null, -1)
const _hoisted_9 = { class: "uppercase my-[10px]" }
const _hoisted_10 = { class: "w-full md:my-[0px] my-[20px] md:w-[calc(100%-240px)] relative bg-white md:mx-[10px] px-[10px] py-[50px]" }
const _hoisted_11 = { class: "md:py-[40px] md:px-[20px] px-[10px] py-[30px]" }
const _hoisted_12 = { class: "py-[15px]" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { class: "text-cyan-600 uppercase font-bold text-1xl" }, "About", -1)
const _hoisted_14 = { class: "inline-flex text-justify" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "py-[15px]" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-cyan-600 uppercase font-bold text-1xl" }, "Profile details")
], -1)
const _hoisted_16 = { class: "py-[15px] flex justify-between items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h1", { class: "text-cyan-600 uppercase text-1xl" }, "Full name", -1)
const _hoisted_18 = { class: "flex justify-start items-center w-[calc(100%/2)]" }
const _hoisted_19 = { class: "uppercase text-justify" }
const _hoisted_20 = { class: "py-[15px] flex justify-between items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h1", { class: "text-cyan-600 uppercase text-1xl" }, "Job", -1)
const _hoisted_22 = { class: "flex justify-start items-center w-[calc(100%/2)]" }
const _hoisted_23 = { class: "text-justify" }
const _hoisted_24 = { class: "py-[15px] flex justify-between items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h1", { class: "text-cyan-600 uppercase text-1xl" }, "Phone", -1)
const _hoisted_26 = { class: "flex justify-start items-center w-[calc(100%/2)]" }
const _hoisted_27 = { class: "text-justify" }
const _hoisted_28 = { class: "py-[15px] h-auto flex justify-between items-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h1", { class: "text-cyan-600 uppercase text-1xl" }, "Email", -1)
const _hoisted_30 = { class: "flex justify-start relative items-center w-[calc(100%/2)]" }
const _hoisted_31 = { class: "text-justify max-w-[100%] h-auto" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-gray-400 py-[50px] flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-sm" }, "© 2023 Cotonou Cadjehoun, Tous droits réservés.")
], -1)

import headerComponent from '../components/headerComponentAdmin.vue'
import linkProfile from '../components/linkProfile.vue'
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import axiosInstance from '@/plugins/axios';



export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileOverview',
  setup(__props) {

const pageTitle = ref('Profile Overview'); 
const router = useRouter()
onMounted(() => {
    document.title = pageTitle.value; 
});


const logout = () => {
    localStorage.clear();
    router.push('/');
};

let user = ref({
});

const fetchUserProfile = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    const response = await axiosInstance.get('/auth/users/me/', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    user.value = response.data;
  } catch (error) {
    console.error(error);
  }
};

onMounted(() => {
  fetchUserProfile();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(headerComponent),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("h1", _hoisted_9, _toDisplayString(_unref(user).firstname) + " " + _toDisplayString(_unref(user).lastname), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(linkProfile),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(user).about), 1)
              ]),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(user).firstname) + " " + _toDisplayString(_unref(user).lastname), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(user).job), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(user).phone), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(user).email), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_32
  ]))
}
}

})